import { SxProps } from '@mui/material';

export const formControlStyles: SxProps = {
  backgroundColor: 'inherit',
};
